import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { buildButton, formatClassName } from '../Util';

/** the object props for building a footer from Utils */
const ButtonObjectPropType = PropTypes.shape({
  /** function to be called on click */
  action: PropTypes.func,
  /** bsClass applied to button */
  class: PropTypes.string,
  /** is button disabled */
  disabled: PropTypes.bool,
  /** content rendered inside the button */
  label: PropTypes.any
});

/** props for building a button by passing an element or building from Utils */
const ButtonPropType = PropTypes.oneOfType([
  PropTypes.element,
  ButtonObjectPropType
]);

/** the props for creating a PageFooter button */
export const PageFooterButtonsPropType = PropTypes.arrayOf(ButtonPropType);

/** renders the standard page footer used in Foundry */
export default class PageFooter extends Component {
  static propTypes = {
    /** adds a class to the PageFooter button container */
    footerButtonBarClass: PropTypes.string,
    /** configures the buttons rendered in the footer */
    footerButtons: PageFooterButtonsPropType,
    /** adds a class to the PageFooter wrapper */
    footerClass: PropTypes.string
  }

  static defaultProps = {
    footerButtons: [],
    footerClass: "row"
  };

  renderButtons = () => {
    const { footerButtons, footerButtonBarClass } = this.props;
    if (!footerButtons || !footerButtons.length) {
      return null;
    }
    const buttonBarClassName = formatClassName([
      'page-footer-buttonbar',
      footerButtonBarClass
    ]);
    return (
      <div className={buttonBarClassName}>
        {footerButtons.map(this.renderButton)}
      </div>
    );
  };

  renderButton = (button, key) => {
    if (typeof button === "function") {
      return button;
    }
    if (!button.action) {
      return null;
    }
    return buildButton(button.action,
      button.label,
      "btn",
      button.class || "primary",
      button.disabled || false,
      { key });
  };

  render() {
    const { footerClass } = this.props;
    const pageFooterClassName = formatClassName([
      'page-footer',
      footerClass
    ]);
    return (
      <div className={pageFooterClassName}>
        {this.renderButtons()}
      </div>
    );
  }
}
